// Constants shared by FolderSearchInput and its tests. Lives in a .ts file
// so it can be imported alongside the component without breaking React
// Fast Refresh (which requires .tsx files to export only components).

// 300ms is the typical typeahead tradeoff: fast enough to feel responsive
// on a single extra keystroke, slow enough to avoid firing on every
// character in a burst-typed query.
export const SEARCH_DEBOUNCE_MS = 300;

// 1-character queries produce noisy, wide-matching results and cost a
// Graph call each. 2 is the minimum that narrows enough to be useful.
export const SEARCH_MIN_QUERY_LENGTH = 2;
